import type { Tealium } from 'src/types/appState';

import { getViewEventDataFromState } from './getViewEventDataByPage';
import type { ViewEventData } from './type';

export const getViewEventData = (tealium: Tealium): ViewEventData =>
  getViewEventDataFromState(tealium);
